const FieldComponentTypes = require('./fieldComponentTypes');

const componentLoaders = {
    AgeField: () => require('./AgeField'),
    AutocompleteField: () => require('./AutocompleteField'),
    CampusPlaceField: () => require('./CampusPlaceField'),
    CheckboxField: () => require('./CheckboxField'),
    ChoiceWithSpecifyField: () => require('./ChoiceWithSpecifyField'),
    DateField: () => require('./DateField'),
    DateTimeField: () => require('./DateTimeField'),
    EmojiField: () => require('./EmojiField'),
    FileField: () => require('./FileField'),
    ColorField: () => require('./ColorField'),
    InterestsInputField: () => require('./InterestsInputField'),
    MultiSelectField: () => require('./MultiSelectField'),
    PlaceField: () => require('./PlaceField'),
    RadioField: () => require('./RadioField'),
    SelectField: () => require('./SelectField'),
    SelectWithSpecifyField: () => require('./SelectWithSpecifyField'),
    SliderWithOptOutField: () => require('./SliderWithOptOutField'),
    SwitchField: () => require('./SwitchField'),
    TextAlertsPreferenceField: () => require('./TextAlertsPreferenceField'),
    TextField: () => require('./TextField'),
    TextareaField: () => require('./TextareaField')
};

const internals = {};

internals.defineLazyComponent = (target, name, loadComponent) => {

    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        get() {
            const Component = loadComponent();

            Object.defineProperty(target, name, {
                configurable: true,
                enumerable: true,
                value: Component
            });

            return Component;
        }
    });
};

internals.buildLazyComponents = (loaders = componentLoaders) => Object.entries(loaders)
    .reduce((collector, [name, loadComponent]) => {

        internals.defineLazyComponent(collector, name, loadComponent);
        return collector;
    }, {});

const componentsByName = internals.buildLazyComponents();

exports.componentsByName = componentsByName;
exports.componentsByType = componentsByName;
exports.componentNames = FieldComponentTypes.FIELD_COMPONENT_TYPES;
exports.componentLoaders = componentLoaders;
exports.preloadComponents = () => {

    Object.keys(componentLoaders).forEach((componentName) => componentsByName[componentName]);
    return componentsByName;
};
exports.internals = internals;
